/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentLocationResponse } from './AppointmentLocationResponse';
import {
    AppointmentLocationResponseFromJSON,
    AppointmentLocationResponseFromJSONTyped,
    AppointmentLocationResponseToJSON,
    AppointmentLocationResponseToJSONTyped,
} from './AppointmentLocationResponse';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { AppointmentAvailabilityVariantResponse } from './AppointmentAvailabilityVariantResponse';
import {
    AppointmentAvailabilityVariantResponseFromJSON,
    AppointmentAvailabilityVariantResponseFromJSONTyped,
    AppointmentAvailabilityVariantResponseToJSON,
    AppointmentAvailabilityVariantResponseToJSONTyped,
} from './AppointmentAvailabilityVariantResponse';

/**
 * 
 * @export
 * @interface AppointmentAvailabilityResponse
 */
export interface AppointmentAvailabilityResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof AppointmentAvailabilityResponse
     */
    appointmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {Array<AppointmentLocationResponse>}
     * @memberof AppointmentAvailabilityResponse
     */
    locations: Array<AppointmentLocationResponse>;
    /**
     * 
     * @type {Array<AppointmentAvailabilityVariantResponse>}
     * @memberof AppointmentAvailabilityResponse
     */
    variants: Array<AppointmentAvailabilityVariantResponse>;
}

/**
 * Check if a given object implements the AppointmentAvailabilityResponse interface.
 */
export function instanceOfAppointmentAvailabilityResponse(value: object): value is AppointmentAvailabilityResponse {
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('locations' in value) || value['locations'] === undefined) return false;
    if (!('variants' in value) || value['variants'] === undefined) return false;
    return true;
}

export function AppointmentAvailabilityResponseFromJSON(json: any): AppointmentAvailabilityResponse {
    return AppointmentAvailabilityResponseFromJSONTyped(json, false);
}

export function AppointmentAvailabilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentAvailabilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['appointmentId']),
        'locations': ((json['locations'] as Array<any>).map(AppointmentLocationResponseFromJSON)),
        'variants': ((json['variants'] as Array<any>).map(AppointmentAvailabilityVariantResponseFromJSON)),
    };
}

export function AppointmentAvailabilityResponseToJSON(json: any): AppointmentAvailabilityResponse {
    return AppointmentAvailabilityResponseToJSONTyped(json, false);
}

export function AppointmentAvailabilityResponseToJSONTyped(value?: AppointmentAvailabilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['appointmentId']),
        'locations': ((value['locations'] as Array<any>).map(AppointmentLocationResponseToJSON)),
        'variants': ((value['variants'] as Array<any>).map(AppointmentAvailabilityVariantResponseToJSON)),
    };
}

